import type { WebhookLogDto } from "@/api/dtos";
import type { WebhookLog, WebhookOutcome, WebhookSource } from "@/api/webhook-log/_models/WebhookLog";

export const toWebhookLogFromWebhookLogDto = (dto: WebhookLogDto): WebhookLog => {
  const hasPayload = dto.payload !== null && dto.payload !== undefined;

  return {
    id: dto.id,
    source: dto.source as WebhookSource,
    event: dto.event ?? undefined,
    outcome: dto.outcome as WebhookOutcome,
    error: dto.error ?? undefined,
    receivedAt: dto.receivedAt,
    replayOf: dto.replayOf ?? undefined,
    canReplay: dto.authorized && hasPayload,
  };
};
